module.exports = __webpack_public_path__ + "static/media/ally_pro_web_6.f9836fb7.jpg";